// extracted by mini-css-extract-plugin
export default {"container":"src-components-Modules-revamp-VisibilityDisplay-css-module__container--1NmQ3","block":"src-components-Modules-revamp-VisibilityDisplay-css-module__block--HlmTF"};